import { render } from "./ResolutionOthers.html?vue&type=template&id=9ab7287c&ts=true"
import script from "./ResolutionsOthers.vue?vue&type=script&lang=ts"
export * from "./ResolutionsOthers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__